import MoreVert from '@mui/icons-material/MoreVert'
import { Menu, MenuItem } from '@mui/material'
import { useContext, useState } from 'react'
import { ArticleLayoutCardComponent } from 'src/consumer/components/Tile/components/layoutCards/ArticleLayoutCard'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { TimerGridItemMenuButton } from './styledComponents'

export default function TimerGridListingPage({
  items,
  getTitleField,
  getActionButtonLogic,
  getMainImage,
  getSubtitleField,
  getSecondaryText = () => {},
  openTimerEditAddDialog = () => {},
}) {
  const { profileData } = useContext(ProfileContext)

  return (
    <>
      {items?.map((item, index) => (
        <TimerGridItem
          key={index}
          getActionButtonLogic={getActionButtonLogic}
          getMainImage={(item) => getMainImage(item, index)}
          getTitleField={getTitleField}
          item={item}
          getSecondaryText={getSecondaryText}
          getSubtitleField={getSubtitleField}
          // editCurrentItem={openTimerEditAddDialog}
          editCurrentItem={
            profileData?.userId === item?.meditation?.privateUserId
              ? (item) => {
                  openTimerEditAddDialog(item)
                }
              : null
          }
        />
      ))}
    </>
  )
}

function TimerGridItem({
  item,
  getTitleField,
  getActionButtonLogic,
  getMainImage,
  getSubtitleField,
  getSecondaryText = () => {},
  editCurrentItem,
}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)

  function openMenu(event) {
    event.stopPropagation()
    setMenuAnchorEl(event.currentTarget)
  }

  function closeMenu() {
    setMenuAnchorEl(null)
  }

  function handleEditButton() {
    const meditation = item?.meditation

    editCurrentItem({
      ...meditation,
      preferredTimes: item?.timeOfPractices,
    })
    closeMenu()
  }

  return (
    <>
      <ArticleLayoutCardComponent
        getActionButtonLogic={getActionButtonLogic}
        getMainImage={getMainImage}
        getTitleField={getTitleField}
        item={item}
        getSecondaryText={getSecondaryText}
        getSubtitleField={getSubtitleField}
        useMainImageAsCompleteUrl
        layoutCardContainerStyles={{ position: 'relative' }}
      >
        {editCurrentItem && (
          <TimerGridItemMenuButton size="small" onClick={openMenu}>
            <MoreVert />
          </TimerGridItemMenuButton>
        )}
      </ArticleLayoutCardComponent>
      <Menu
        id="basic-menu"
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={closeMenu}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleEditButton}>Edit</MenuItem>
      </Menu>
    </>
  )
}

/* <SquareMidCardSingleCard
          key={index}
          item={item}
          getTitleField={getTitleField}
          getActionButtonLogic={getActionButtonLogic}
          getMainImage={getMainImage}
        /> */
